import { defineMessages } from 'react-intl';

export const metadatas = {
  default: defineMessages({
    title: {
      defaultMessage: 'Sorare: Own Your Game',
    },
    description: {
      defaultMessage:
        "Collect, play and win officially licensed digital cards featuring the world's best global football, MLB and NBA players.",
    },
  }),
  landing: defineMessages({
    title: {
      defaultMessage:
        'Play Sorare Fantasy Football, NBA, MLB w/tradable player cards',
    },
    description: {
      defaultMessage:
        'Play Sorare’s Fantasy Football, MLB & NBA games. Collect, buy, sell and compete with tradable digital player cards to win rewards.',
    },
  }),
  card: defineMessages({
    title: {
      defaultMessage: '{scarcity} Card of {display_name} – {season}',
    },
    description: {
      defaultMessage:
        'Collect, trade and play with {display_name} Sorare cards available in different scarcities and Own Your Game',
    },
  }),
  player: defineMessages({
    title: {
      defaultMessage: '{display_name} – Player Profile',
    },
    description: {
      defaultMessage:
        'Find all the statistics of {display_name}. Collect and trade officially licensed digital cards of your favourite player on Sorare',
    },
  }),
  playerCard: defineMessages({
    title: {
      defaultMessage: '{display_name} Cards – Collect and Trade',
    },
    description: {
      defaultMessage:
        'Find all the officially licensed digital cards of {display_name}: Limited, Rare, Super Rare, Unique. Only on Sorare.',
    },
  }),
  userGallery: defineMessages({
    title: {
      defaultMessage: '{username}’s Gallery and Profile',
    },
    description: {
      defaultMessage: '{username} Sorare cards gallery and Profile',
    },
  }),
  managerHome: defineMessages({
    title: {
      defaultMessage: 'Manager Home',
    },
    description: {
      defaultMessage: '{username} Sorare Manager Home',
    },
  }),
  myGallery: defineMessages({
    title: {
      defaultMessage: 'My Gallery',
    },
    description: {
      defaultMessage: '{username} Sorare Cards gallery',
    },
  }),
  press: defineMessages({
    title: {
      defaultMessage: 'Press articles about us',
    },
  }),
  licensedPartners: defineMessages({
    title: {
      defaultMessage: '300+ licensed clubs',
    },
    description: {
      defaultMessage:
        'We have partnered with the best sports leagues and clubs in the world to bring our next-level fantasy sports game to fans across the globe',
    },
  }),
  coverage: defineMessages({
    title: {
      defaultMessage: 'Covered Competitions',
    },
    description: {
      defaultMessage:
        'We cover dozens of competitions every week, allowing you to follow the performances of your players around the world',
    },
  }),
  collection: defineMessages({
    title: {
      defaultMessage: "{username}'s collection: {collectionName}",
    },
  }),
};
